import { DollarCircleIcon, GraphIcon } from '@/components/dashboard/icons'
import { KpiCard } from '@/components/dashboard/KpiCard'
import { ProfitCarousel } from '@/components/dashboard/ProfitCarousel'
import { PerformanceChart } from '@/components/dashboard/PerformanceChart'
import { Footer } from '@/components/layout/footer'
import { PageShell } from '@/components/layout/PageShell'

const KPI_CARDS = [
	{
		title: 'Total Volume',
		icon: GraphIcon,
		gradientClassName: 'bg-gradient-to-b from-[hsl(var(--accent-blue))] to-info',
		bannerTextClassName: 'text-background',
		columns: [
			{ label: 'Sports', percent: '84.2%', positive: true, value: '$ 0', decimals: '.0' },
			{ label: 'Casino', percent: '0%', positive: false, value: '$ 7 124 748', decimals: '.0' },
		] as [any, any],
	},
	{
		title: 'User Winnings',
		icon: DollarCircleIcon,
		gradientClassName: 'bg-gradient-to-b from-[hsl(var(--accent-green))] to-success',
		bannerTextClassName: 'text-background',
		columns: [
			{ label: 'Sports', percent: '0%', positive: false, value: '$ 0', decimals: '.0' },
			{ label: 'Casino', percent: '0%', positive: false, value: '$ 175 874', decimals: '.0' },
		] as [any, any],
	},
	{
		title: 'Betting Exchange Profits',
		icon: GraphIcon,
		gradientClassName: 'bg-gradient-to-b from-warning to-warning/70',
		bannerTextClassName: 'text-background',
		columns: [
			{ label: 'Sports', percent: '84.2%', positive: true, value: '$ 0', decimals: '.0' },
			{ label: 'Casino', percent: '0%', positive: false, value: '$ 227 875', decimals: '.0' },
		] as [any, any],
	},
]

const SPORTS_CHART_DATA = [
	{ month: '2024-05', profit: 40000, volume: 20000 },
	{ month: '2024-06', profit: 340000, volume: 60000 },
	{ month: '2024-07', profit: 210000, volume: 90000 },
	{ month: '2024-08', profit: 10000, volume: 40000 },
	{ month: '2024-09', profit: 220000, volume: 60000 },
	{ month: '2024-10', profit: 190000, volume: 50000 },
]

const CASINO_CHART_DATA = [
	{ month: '2024-05', profit: 60000, volume: 90000 },
	{ month: '2024-06', profit: 120000, volume: 60000 },
	{ month: '2024-07', profit: 90000, volume: 260000 },
	{ month: '2024-08', profit: 140000, volume: 40000 },
	{ month: '2024-09', profit: 110000, volume: 90000 },
	{ month: '2024-10', profit: 200000, volume: 130000 },
]

export default function Dashboard() {
	return (
		<PageShell footer={<Footer />}>
			<div className='grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3'>
				{KPI_CARDS.map((kpi) => (
					<KpiCard key={kpi.title} {...kpi} />
				))}
			</div>

			<ProfitCarousel />

			<div className='grid grid-cols-1 gap-4 xl:grid-cols-2'>
				<PerformanceChart
					title='Sports Betting'
					data={SPORTS_CHART_DATA}
					profitColor='hsl(var(--success))'
					volumeColor='hsl(var(--warning))'
					profitGradientId='sportsProfitGradient'
					volumeGradientId='sportsVolumeGradient'
				/>
				<PerformanceChart
					title='Casino / Original Betting'
					data={CASINO_CHART_DATA}
					profitColor='hsl(var(--purple))'
					volumeColor='hsl(var(--pink))'
					profitGradientId='casinoProfitGradient'
					volumeGradientId='casinoVolumeGradient'
				/>
			</div>
		</PageShell>
	)
}
